import { Card, Divider } from "@mui/material";
import dayjs from "dayjs";
import { useTranslations } from "use-intl";

import { OrderLabel } from "@/features/bookings/components/OrderLabel";
import type {
  FindUserReservationsFlightReservation,
  FindUserReservationsHotelReservation,
} from "@/types/codegen";
import { formatCurrency } from "@/utils/currency";

type Props = {
  reservation:
    | FindUserReservationsFlightReservation
    | FindUserReservationsHotelReservation;
  onClick?: () => void;
};

export const OrderCardWithoutReservation = ({
  reservation,
  onClick,
}: Props) => {
  const t = useTranslations();
  return (
    <Card
      className="flex flex-col gap-4 p-4"
      onClick={onClick}
      sx={{
        borderRadius: "var(--radius-3xl)",
      }}
      elevation={0}
    >
      <div className="flex w-full justify-between">
        <span>
          {`${t("reservations.bookedAt")}: ${dayjs(reservation.createdAt).format("DD MMM, YYYY")}`}
        </span>

        <OrderLabel status={reservation.status} />
      </div>
      <Divider />
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span>{`${t("reservations.id")}: ${reservation.id}`}</span>
        <div className="grow text-end">
          <strong>
            {formatCurrency(reservation.price, reservation.currency)}
          </strong>
        </div>
      </div>
    </Card>
  );
};
